import en from "@/app/locales/en.json";
import sp from "@/app/locales/sp.json";

export default { en, sp };
